import gql from 'graphql-tag'

export default {
  accountInvoice() {
    return {
      query: gql`
        query Query($accountInvoiceId: ID!) {
          accountInvoice(id: $accountInvoiceId) {
            id
            invoice_number
            status
            date_opened
            opening_balance
            credits
            credits_gst
            debits
            debits_gst
            commissions
            commissions_gst
            payments
            closing_balance
            gst_value
            date_issued
            date_sent
            date_closed
            transactions {
              id
              type
              location_id
              description
              gst
              gst_value
              value
              breakdown
              created_at
              is_commission
              is_payment
              creator {
                full_name
              }
              payment {
                receipt_url
                refunded
                refunded_amount
                amount
                status
                payment_type
                transaction_reference
                disputed
                refund_id
                receipt_id
                type
              }
            }
          }
        }
      `,
      variables() {
        return {
          accountInvoiceId: this.accountInvoiceId
        }
      }
    }
  }
}
